import { useRef, useState } from 'react';
import { levelLabel, levelColor, ghostLevelStyle } from './constants';
import WorkspacesPopover from './WorkspacesPopover';

// Coluna "Áreas de trabalho" — chips (até 3, depois +N). Herdado do grupo
// aparece "fantasma" (texto apagado, borda tracejada); explícito/negado
// aparece sólido na cor do nível — arquitetura-v2.md §6.4.
export default function WorkspacesCell({ user, workspaces, defaultLevel, canEdit, onChanged }) {
  const [open, setOpen] = useState(false);
  const btnRef = useRef(null);
  const list = workspaces || [];
  const preview = list.slice(0, 3);
  const extra = list.length - preview.length;

  return (
    <div className="relative">
      <button
        ref={btnRef}
        type="button"
        onClick={() => setOpen((v) => !v)}
        className="flex items-center gap-1 flex-wrap text-left hover:opacity-90 transition-opacity min-h-[28px] max-w-full"
      >
        {list.length === 0 && <span className="text-white/25 text-xs">—</span>}
        {preview.map((w) => {
          const ghost = w.source === 'role';
          return (
            <span
              key={w.id}
              title={`${w.name} · ${levelLabel(w.level)}${ghost ? ' (herdado do grupo)' : ''}`}
              className={`inline-flex items-center gap-1 rounded px-1.5 py-0.5 text-[11px] font-medium max-w-[110px] truncate border ${
                ghost ? '' : 'text-white font-semibold border-transparent'
              }`}
              style={ghost ? ghostLevelStyle(w.level) : { backgroundColor: levelColor(w.level) }}
            >
              {w.name}
            </span>
          );
        })}
        {extra > 0 && <span className="text-[11px] text-text-secondary shrink-0">+{extra}</span>}
      </button>

      {open && (
        <WorkspacesPopover
          anchorRef={btnRef}
          user={user}
          workspaces={list}
          defaultLevel={defaultLevel}
          canEdit={canEdit}
          onClose={() => setOpen(false)}
          onChanged={onChanged}
        />
      )}
    </div>
  );
}
